import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsMultiNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M32.566 29.43a2 2 0 001.034.288v.05a2 2 0 001.77-1.07l1.48-2.77a1.25 1.25 0 011.11-.66h5.62v-2h-5.65a3.26 3.26 0 00-2.88 1.72l-1.49 2.77-4.22-8a1.995 1.995 0 00-1.76-1.05 1.999 1.999 0 00-1.76 1.05l-1.49 2.79a1.262 1.262 0 01-1.11.67H18.8v2h4.42a3.252 3.252 0 002.91-1.73l1.47-2.79 4.23 7.95a2.007 2.007 0 00.736.782z"
        fill=""
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.01 40.788a16.79 16.79 0 112.72-33.36 1.015 1.015 0 01.422.172 16.79 16.79 0 017.222.002A16.79 16.79 0 0147.78 23.998a16.81 16.81 0 01-16.79 16.79c-1.225 0-2.44-.134-3.624-.396a16.795 16.795 0 01-3.636.396 16.8 16.8 0 01-3.214-.316 1.03 1.03 0 01-.186.056 16.784 16.784 0 01-3.32.26zm-1.249-2.027a14.791 14.791 0 01-.12-29.46 16.786 16.786 0 00-7.9 19.733 16.793 16.793 0 008.02 9.727zm7.248.009A14.787 14.787 0 019.063 25.827a14.785 14.785 0 018.59-15.308 14.79 14.79 0 015.356-1.293 16.781 16.781 0 00-8.486 11.496 16.791 16.791 0 008.486 18.048zm-.236-27.07a14.789 14.789 0 018.217-2.492 14.81 14.81 0 0114.79 14.79 14.791 14.791 0 11-23.007-12.297z"
        fill=""
      />
    </svg>
  )
);
SvgSportsMultiNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsMultiNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsMultiNormalLarge;
